export function useBigScoreImage() {
    const generateBlob = async (el: HTMLElement | null): Promise<Blob | null> => {
        if (!import.meta.client || !el) return null;
        // Garde : html-to-image appelle getComputedStyle, qui exige un Element réel
        // (et non un nœud commentaire placeholder Vue d'un composant pas encore monté).
        if (!(el instanceof HTMLElement)) return null;
        try {
            const { toBlob } = await import("html-to-image");
            // skipFonts: on n'inline pas les feuilles de style (polices système),
            // ce qui évite une SecurityError sur les CSS cross-origin qui ferait
            // échouer la génération.
            return await toBlob(el, { pixelRatio: 2, cacheBust: true, skipFonts: true });
        } catch (e) {
            console.error("BIG Score image generation failed:", e);
            return null;
        }
    };

    const downloadImage = async (el: HTMLElement | null, fileName: string): Promise<boolean> => {
        const blob = await generateBlob(el);
        if (!blob) return false;

        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        return true;
    };

    // Convertit une URL d'image (photo signée) en dataURL pour éviter un canvas
    // "tainted" quel que soit le CORS du storage. Retourne null en cas d'échec.
    const fetchImageAsDataUrl = async (imageUrl: string): Promise<string | null> => {
        if (!import.meta.client) return null;
        try {
            const res = await fetch(imageUrl, { mode: "cors" });
            if (!res.ok) return null;
            const blob = await res.blob();
            return await new Promise<string | null>((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(typeof reader.result === "string" ? reader.result : null);
                reader.onerror = () => resolve(null);
                reader.readAsDataURL(blob);
            });
        } catch {
            return null;
        }
    };

    return { generateBlob, downloadImage, fetchImageAsDataUrl };
}
